export default __webpack_public_path__ + "static/media/bg-study.771bf6ff.svg";